import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 05/01/2025</p>
      <p>
        Codeify LLC operates the website deliquentauction.com. This Privacy Policy explains how we collect, use, and protect your personal information when you use our Site.
      </p>
      <h2>1. Information We Collected</h2>
      <p>
        When you register or use the Site, we may collect the following information:
        <li>* Email address – collected during account registration and subscription checkout.</li>
        We do not collect sensitive personal information such as addresses, phone numbers, government IDs, or payment details directly (payment processing is handled by a third-party provider).   
      </p>
      <h2>22. How We Use Your Information</h2>
      <p>
        We use your email address to:
        <li>* Create and manage your account</li>
        <li>* Process your subscription</li>
        <li>* Communicate important service updates or billing notices</li>
        <li>* Send occasional product or feature updates (you can opt out anytime)</li>
      </p>
      <h2>3. Sharing of Information</h2>
      <p>
        We do not sell or share your personal information with third parties, except:
        <li>* With third-party service providers (e.g., payment processors) necessary to operate our business</li>
        <li>* If required by law, subpoena, or other legal process</li>
      </p>
      <h2>4. Data Security</h2>
      <p>
        We implement reasonable safeguards to protect your information. 
        However, no system can be guaranteed 100% secure, and you use the Site at your own risk.
      </p>
      <h2>5. Email Communications</h2>
      <p>
        By registering, you agree to receive administrative emails (e.g., subscription confirmations, billing issues). 
        You may also receive optional promotional messages, which you can unsubscribe from at any time.
      </p>
      <h2>6. Cookies</h2>
      <p>
        We may use cookies and similar technologies to:
        <li>* Maintain user sessions</li>
        <li>* Analyze site traffic and usage</li>
        <li>* Improve user experience</li>
        You can adjust your browser settings to disable cookies, but doing so may limit certain features.
      </p>
      <h2>7. Children's Privacy</h2>
      <p>
        This Site is not intended for children under 18. 
        We do not knowingly collect personal information from anyone under 18.
      </p>
      <h2>8. Your Rights</h2>
      <p>
        You may:
        <li>* Update or delete your account information at any time by logging in</li>
        <li>* Request that we delete your account and associated email address by contacting us</li>
      </p>
      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. 
        Any changes will be posted on this page with an updated effective date.
      </p>
      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at: support@deliquentauction.com
      </p>
    </div>
  );
};

export default PrivacyPage;
